import { GroupItem } from '../../../server/typings'
import { MoneyPoolInput } from '../../../typings'
import serverData from '../utils/server-data'
import { groupApi } from './groupApi'

interface CreateMoneyPoolPayload {
  input: MoneyPoolInput
}

export const createGroupApiSlice = groupApi.injectEndpoints({
  endpoints: (builder) => ({
    createGroup: builder.mutation<GroupItem, CreateMoneyPoolPayload>({
      query: (input) => ({
        url: `/create`,
        method: 'POST',
        body: input,
        headers: { 'X-CSRF-Token': serverData._csrf },
      }),
      invalidatesTags: (_result, error) => (error ? [] : ['eligibility']),
    }),
  }),
})

export const { useCreateGroupMutation } = createGroupApiSlice
